import {
  FIELDSET,
  ItemIds,
  LAYOUT_LIST,
  MESSAGE,
  MESSAGE_RESPONSE,
  TEXT,
  TEXT_MESSAGES,
  ADD_NEW_ITEM
} from '../items';
import { ItemDefinition } from '../items/Item';
import { Translator } from '../Translator';
import { translate } from './translate';
import { t } from 'ttag';
import { detectMultiSelect } from '~/training/sequence/templates/translators/itemHelpers/Quiz';
import { useEditorStore } from '~/shell/Store';
import {
  optionalFieldsInEditor,
  optionalFieldValues,
  editorCueValues
} from '../utils/optionalFields';

export const Quiz10: Translator = sequence => {
  const root = translate(sequence, () => null);
  const messages: ItemDefinition<ItemIds>[] = [];

  let isContentEditable = false;
  try {
    const { contentEditable } = useEditorStore.getState();
    isContentEditable = !!contentEditable;
  } catch (e) {
    // ignore if store not available
  }

  sequence.items?.forEach(item => {
    if (item.__typename === 'List') {
      const elementItems = item?.items ? item.items : [];
      elementItems?.forEach(element => {
        const valuesData = element.title ? { sender: element.title } : {};

        messages.push({
          type: MESSAGE,
          id: element.id,
          start: 0,
          values: valuesData,
          items: [
            {
              type: TEXT,
              id: `${element.id}_body`,
              items: [],
              values: {
                ...optionalFieldValues(
                  optionalFieldsInEditor(['body']),
                  'body',
                  'Add message'
                ),
                value: element.body
              }
            }
          ]
        });
      });

      if (isContentEditable) {
        messages.push({
          type: ADD_NEW_ITEM,
          id: `_add_new_item`,
          items: [],
          values: {
            type: 'text'
          }
        });
      }
    }

    if (item.__typename == 'Question') {
      const elementItems = item?.items ? item.items : [];
      const _btn: ItemDefinition<ItemIds>[] = [];

      elementItems.forEach(element => {
        _btn.push({
          type: MESSAGE_RESPONSE,
          id: element.id,
          values: {
            correct: element.correct,
            feedback: element.feedback,
            feedbackAudios: element.feedbackAudios?.[0],
            group: `group_${element.id}_${item.id}`,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            llamaSurvey: item?.llamaSurvey,
            disableBlockers: item?.llamaSurvey === true,
            correctAnswers: detectMultiSelect(elementItems)
          },
          items: [
            {
              type: TEXT,
              id: `${element.id}_value`,
              items: [],
              values: {
                ...editorCueValues('Add answer'),
                value: element.value,
                textAlignment: false
              }
            }
          ]
        });
      });

      messages.push({
        type: FIELDSET,
        id: 'FieldSetAndLegend',
        values: {
          title: t`Choose the correct answer(s)`
        },
        items: _btn
      });
    }
  });

  root.items.push({
    id: 'center_side',
    type: LAYOUT_LIST,
    values: { align: 'center' },
    items: [
      {
        type: TEXT_MESSAGES,
        id: '1',
        items: messages,
        values: {
          value: '',
          variant: 'llama',
          weNeedToUseOwnFeedback: true
        }
      }
    ]
  });

  return root;
};
